import {
	TEAM_GET, TEAM_MEMBER_ADD,GET_TEAM_MEMBER,PUBLIC_TEAMS
} from '../actions/ActionTypes';

const initialState = {
	myTeam: [],
	teamMembers: [],
	pendingTeams:[],
	approvedTeams:[],
	publicTeams:[]
 };

export default function (state = initialState, action) {
	switch (action.type) {
		case TEAM_GET:
			return {
				...state,
				myTeam: action.data,
				approvedTeams:action.approvedTeams,
				pendingTeams:action.pendingTeams				
            };
        case TEAM_MEMBER_ADD:
			return {
				...state,
                // teamMembers: action.data,				
			};
		case GET_TEAM_MEMBER:
		return {
			...state,
			teamMembers: action.data,			
		};
		case PUBLIC_TEAMS:
		return {
			...state,
			publicTeams: action.data,			
		};
		default:
			return state;
	}
}